"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionCancelledData = void 0;
var runtypes_1 = require("runtypes");
var runtypeImplementing_1 = require("../../../util/runtypeImplementing");
var UUID_1 = require("../../../util/UUID");
var Data_1 = require("./Data");
// Sent when a session is cancelled.
exports.SessionCancelledData = (0, runtypeImplementing_1.runtypeImplementing)(Data_1.Data)((0, runtypes_1.Record)({
    type: (0, runtypes_1.Literal)("sessionCancelled"),
    session: UUID_1.UUID,
}));
//# sourceMappingURL=SessionCancelledData.js.map